import { VALIDATE_CODES } from './codes';
export var maxLength = function (length, errorText) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function (value, values, texts) {
        if (!value) {
            return '';
        }
        if (value && value.length < length + 1) {
            return '';
        }
        return (errorText || texts[VALIDATE_CODES.maxLength]).replace(/{{length}}/, String(length));
    };
};
//# sourceMappingURL=maxLength.js.map